import { DeliveredStatus } from '@amzn/aet-coachingform-kit/lib/types';
import { MetricsOption } from '@amzn/aet-galactus-kit';

export const LighthouseDefaultName = new Map<string, [string, string]>([
  [MetricsOption.RAP.toString(), ['cs_perfportal_rap', 'RAP']],
  [MetricsOption.CCX.toString(), ['cs_perfportal_ccx', 'CCX']],
  ['CCX_V2', ['cs_perfportal_ccx_topbox', 'CCX Overall Service (Top-Two Box)']],
  [
    MetricsOption.CCX_NEG.toString(),
    ['cs_perfportal_ccx_bottombox', 'CCX Overall Service (Bottom-Two Box)'],
  ],
  [
    MetricsOption.CCX_NEG_ONEBOX.toString(),
    ['cs_perfportal_ccx_bottom_onebox', 'CCX Overall Service (Bottom Box)'],
  ],
  [MetricsOption.ACHT.toString(), ['cs_perfportal_acht', 'ACHT']],
  [MetricsOption.TR.toString(), ['cs_perfportal_tr', 'Transfer Rate']],
  [MetricsOption.DART.toString(), ['cs_perfportal_dart', 'DART']],
  [MetricsOption.DCR.toString(), ['cs_perfportal_dcr', 'DCR']],
  [MetricsOption.DSR.toString(), ['cs_perfportal_dsr', 'DSR']],
  [MetricsOption.SDR.toString(), ['cs_perfportal_sdr', 'SDR']],
  [
    MetricsOption.CONCESSION_RATE.toString(),
    ['cs_perfportal_concessionRate', 'Concession Rate'],
  ],
  [
    MetricsOption.POLICY_ADHERENCE.toString(),
    ['cs_perfportal_pa', 'Policy Adherence'],
  ],
  [
    MetricsOption.UNDERSTANDABILITY.toString(),
    ['cs_perfportal_lighthouse_understandability', 'Understandability'],
  ],
  [
    MetricsOption.PRRNC.toString(),
    ['cs_perfportal_prrNoConcession', 'PRR - No Concession'],
  ],
  [
    MetricsOption.PRRCI.toString(),
    ['cs_perfportal_prrConcessionIssued', 'PRR - Concession Issued'],
  ],
  [
    MetricsOption.UNDERSTANDABILITY_CONCESSION_ISSUED.toString(),
    [
      'cs_perfportal_lighthouse_understandability_concessionIssued',
      'Understandability - Concession Issued',
    ],
  ],
  [
    MetricsOption.UNDERSTANDABILITY_NO_CONCESSION.toString(),
    [
      'cs_perfportal_lighthouse_understandability_noConcession',
      'Understandability - No Concession',
    ],
  ],
  [MetricsOption.CONSULT_RATE.toString(), ['cs_perfportal_cr', 'Consult Rate']],
  [MetricsOption.PRR.toString(), ['cs_perfportal_prr', 'PRR']],
  [
    MetricsOption.HMD_OFFER_RATE.toString(),
    ['cs_perfporta_lighthouse_hmdOfferRate', 'HMD Offer Rate'],
  ],
  [
    MetricsOption.HMD_RESPONSE_RATE.toString(),
    ['cs_perfportal_responseRate', 'HMD Offer & Answer Rate'],
  ],
  [MetricsOption.QCS.toString(), ['cs_perfportal_qcs', 'QCS']],
  [MetricsOption.FCR.toString(), ['cs_perfportal_fcr', 'FCR']],
  [MetricsOption.ACW.toString(), ['cs_perfportal_acw', 'ACW']],
  [
    MetricsOption.HOLD_TIME.toString(),
    ['cs_perfportal_hold_time', 'Hold Time'],
  ],
  [
    MetricsOption.POLICY_ADHERENCE.toString(),
    ['cs_perfportal_pa', 'Policy Adherence'],
  ],
  [
    MetricsOption.HIGH_SILENCE_RATE.toString(),
    ['cs_perfportal_lighthouse_highSilence', 'High Silence'],
  ],
]);

export const DELIVERY_STATUS_LABEL = {
  [DeliveredStatus.DRAFT]: {
    id: 'cs_perfportal_coaching_status_not_coached',
    default: 'Draft',
  },
  [DeliveredStatus.DELIVERED]: {
    id: 'cs_perfportal_coaching_status_coached',
    default: 'Coached',
  },
  [DeliveredStatus.NOCOACH]: {
    id: 'cs_perfportal_coaching_status_no_session',
    default: 'No session',
  },
  [DeliveredStatus.UNDEFINED]: {
    id: 'cs_perfportal_coaching_status_no_session',
    default: 'No session',
  },
  [DeliveredStatus.OPEN_DELIVERED]: {
    id: 'cs_perfportal_coaching_status_open_delivered',
    default: 'Open(Delivered)',
  },
  [DeliveredStatus.OPEN_REVIEWED]: {
    id: 'cs_perfportal_coaching_status_open_reviewed',
    default: 'Open(Reviewed)',
  },
  [DeliveredStatus.CLOSED]: {
    id: 'cs_perfportal_coaching_status_closed',
    default: 'Closed',
  },
};
